export default function (config, options) {
  console.log('server.ts', { config, options });
}
